import { useState } from 'react';
import { IconButton, Dialog, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import P from 'prop-types';
import { createPercents } from '../../service/commissionSchema.service';
import PercentsComponents from './PercentsComponents';

export default function CommissionPercentsRangeAdd({ open, setOpen, schemaId, mutate, update, channelId }) {
    const [values, setValues] = useState({
        begin: 0,
        end: 0,
        commission: 0,
        description: null,
        loss_percent: 0,
        conversion_percent: 0,
        reduce_percent: 0,
        channelId: null,
    });

    const handleClose = () => {
        setOpen(false);
    };
          
    const submit = async (e) => {
      e?.preventDefault();
    
      const addPercents = {
        commissionSchema_id: schemaId,
        begin: values.begin,
        end: values.end,
        commission: values.commission,
        description: values.description,
        loss_percent: values.loss_percent,
        conversion_percent: values.conversion_percent,
        reduce_percent: values.reduce_percent,
      };

      try {
        await createPercents(addPercents);
  
        toast.success('Comissão adicionada!');
        mutate();
      } catch (error) {
        toast.error('Erro ao adicionar a comissão');
      }
  
      update();
      handleClose();
    };

    const entering = () => {
      setValues({begin: 0, end: 0, commission: 0});
    }

      
    return (
        <div>
          <Dialog
            TransitionProps={{onEntering: entering}}
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            
            maxWidth="md">
            <DialogTitle id="form-dialog-title" style={{ backgroundColor: '#fc986a' }}>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                Nova Comissão
                <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle >
            <form onSubmit={submit}>
              <DialogContent>

                <PercentsComponents 
                  values={values} 
                  setValues={setValues}
                  channelId={channelId}
                />

              </DialogContent>
              <DialogActions style={{position: 'sticky', bottom: 0, backgroundColor:'white', width:'100%',}}>
                <Button onClick={handleClose} color="primary">
                  Cancelar
                </Button>
                <Button type="submit" color="primary">
                  Adicionar
                </Button>
              </DialogActions>
    
            </form>
          </Dialog>
        
        </div>
      );
}
    
CommissionPercentsRangeAdd.propTypes = {
    open: P.bool.isRequired,
    setOpen: P.func.isRequired,
    schemaId: P.number.isRequired,
    mutate: P.func.isRequired,
    update: P.func.isRequired,
    channelId: P.number.isRequired,
  };